// Copiato da https://github.com/react-bootstrap/react-overlays/blob/v1.2.0/src/utils/ownerDocument.js
import ReactDOM from 'react-dom'
import ownerDocument from 'dom-helpers/ownerDocument'

const reactOwnerDocument = (componentOrElement) => {
  return ownerDocument(ReactDOM.findDOMNode(componentOrElement))
}

export default reactOwnerDocument;